
import '@/vue/_apps/donate/donate.web.js'
import '@/vue/_apps/comments/comments.web.js'

import './contact.web.css'
import './contact.vue.js'
